import { Button, Column, Icon, Row, SearchField, Text } from "@amzn/meridian";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { COLORS } from "src/constants/colors";
import { useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import TemplateDisplayCard, { Template } from "./templateDisplayCard";
import filterTokens from "@amzn/meridian-tokens/base/icon/filter";
import { InspectionTemplate } from "src/data/types";

const TemplatesPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { inspectionTemplates } = useAppSelector((state) => state.inspectionTemplate);
  const [templatesToDisplay, setTemplatesToDisplay] = useState<Template[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    setTemplatesToDisplay(inspectionTemplates);
  }, [inspectionTemplates]);
  return (
    <>
      <Column
        className="templates-page"
        height="100vh"
        alignmentVertical="justify"
        backgroundColor={COLORS.DARKER_WHITE}
      >
        <Column>
          <Column
            width="100%"
            backgroundColor={COLORS.WHITE}
            spacingInset="600 500 400"
          >
            <Row>
              <div
                style={{ cursor: "pointer", marginLeft: "50px" }}
                onClick={() => navigate("/")}
              >
                <Icon tokens={chevronLeftLargeTokens} color="primary" />
              </div>
              <Text type="h200">Dashboard</Text>
            </Row>
            <Column>
              <Row>
                <Text type="b500">Choose Inspection</Text>
              </Row>
            </Column>
          </Column>
          <Column spacingInset="none 500">
            <Column>
              {templatesToDisplay.map((template) => (
                <TemplateDisplayCard
                  key={template.templateId}
                  inspectionTemplate={template}
                />
              ))}
              {!templatesToDisplay.length && (
                <Text type="h100">
                  There are no available inspection templates at the moment.
                </Text>
              )}
            </Column>
          </Column>
        </Column>
        <Column>
          <Row spacingInset="500" widths={["fill", "fit"]}>
            <SearchField
              size="large"
              value={searchQuery}
              onChange={setSearchQuery}
              placeholder="Search"
              onSubmit={() => {
                const filteredTemplates = inspectionTemplates.filter(
                  (template) =>
                    template.templateName
                      .toLocaleLowerCase()
                      .includes(searchQuery.toLocaleLowerCase())
                );
                setTemplatesToDisplay(filteredTemplates);
              }}
              searchButton={false}
            />
            <Button type="secondary" size="large">
              <Icon tokens={filterTokens} />
            </Button>
          </Row>
        </Column>
      </Column>
    </>
  );
};

export default TemplatesPage;
